import { render } from "./StorefrontLayout.vue?vue&type=template&id=5e87bd64&scoped=true"
import script from "./StorefrontLayout.vue?vue&type=script&lang=js"
export * from "./StorefrontLayout.vue?vue&type=script&lang=js"

import "./StorefrontLayout.vue?vue&type=style&index=0&id=5e87bd64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e87bd64"]])

export default __exports__